import type { IconSvgObject } from './types';

const ReceiptTurkishLiraIcon: IconSvgObject = [
  ["path", { d: "M9.5 2L12 3.5L14.5 2L17 3.5L20 2V22L17 20.5L14.5 22L12 20.5L9.5 22L7 20.5L4 22V2L7 3.5L9.5 2Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11 8V16H12C13.6569 16 15 14.6569 15 13M9 12L14 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ReceiptTurkishLiraIcon;
